"use client";
import { createContext, useState, useContext, ReactNode } from "react";

export type Base = {
  user: string;
  host: string;
  dataBase: string;
  password: string;
  port: number;
};

export type BaseContextType = {
  base: Base;
  setBase: (base: Base) => void;
};
const BaseContext = createContext<BaseContextType | undefined>(undefined);
export const BaseProvider: React.FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const [base, setBase] = useState<Base>({
    user: "",
    host: "",
    dataBase: "",
    password: "",
    port: 0,
  });
  return (
    <BaseContext.Provider value={{ base, setBase }}>
      {children}
    </BaseContext.Provider>
  );
};
export const useBase = () => {
  const context = useContext(BaseContext);
  if (!context) {
    throw new Error("Erreur Context User");
  }
  return context;
};
